/**
 * Job Application Modal Functionality
 */

document.addEventListener('DOMContentLoaded', function() {
    const applyButtons = document.querySelectorAll('.btn--apply');
    const modal = document.getElementById('job-application-modal');
    const modalClose = document.querySelector('.modal-close');
    const modalOverlay = document.querySelector('.modal-overlay');
    const modalJobTitle = document.getElementById('modal-job-title');

    // Open modal when apply button is clicked
    applyButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();

            const jobId = this.getAttribute('data-job-id');
            const jobTitle = this.getAttribute('data-job-title');

            // Update modal content
            if (modalJobTitle) {
                modalJobTitle.textContent = jobTitle;
            }

            // Set job ID in hidden field if it exists in the form
            const jobIdField = document.querySelector('input[name="job_id"]');
            if (jobIdField) {
                jobIdField.value = jobId;
            }

            // Set job title in hidden field if it exists in the form
            const jobTitleField = document.querySelector('input[name="job_title"]');
            if (jobTitleField) {
                jobTitleField.value = jobTitle;
            }

            // Show modal
            modal.style.display = 'flex';
            document.body.style.overflow = 'hidden';

            // Focus management for accessibility
            setTimeout(() => {
                const firstInput = modal.querySelector('input, textarea, select');
                if (firstInput) {
                    firstInput.focus();
                }
            }, 100);
        });
    });

    // Close modal when close button is clicked
    if (modalClose) {
        modalClose.addEventListener('click', function() {
            closeModal();
        });
    }

    // Close modal when clicking on overlay
    if (modalOverlay) {
        modalOverlay.addEventListener('click', function(e) {
            if (e.target === modalOverlay) {
                closeModal();
            }
        });
    }

    // Close modal with Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.style.display === 'flex') {
            closeModal();
        }
    });

    // Function to close modal
    function closeModal() {
        modal.style.display = 'none';
        document.body.style.overflow = '';

        // Reset form if needed
        const form = modal.querySelector('form');
        if (form) {
            // Don't reset automatically as user might have filled some fields
            // form.reset();
        }
    }

    // Handle form submission success (if using AJAX)
    document.addEventListener('gform_confirmation_loaded', function(event) {
        // Close modal after successful submission
        setTimeout(() => {
            closeModal();
        }, 3000); // Close after 3 seconds to show confirmation
    });

    // Prevent modal content clicks from closing modal
    const modalContent = document.querySelector('.modal-content');
    if (modalContent) {
        modalContent.addEventListener('click', function(e) {
            e.stopPropagation();
        });
    }
});